export function Blocked() {
  return (
    <main className="bg-muted/40 flex min-h-screen items-center justify-center px-4">
      <section aria-labelledby="blocked-title" className="text-center">
        <h1 id="blocked-title" className="text-2xl font-bold">
          Browsing blocked
        </h1>
        <p className="text-muted-foreground mt-2">This site is unavailable.</p>
      </section>
    </main>
  )
}
